"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInWishlist = function (item) {
    if (!window._swat) {
        throw new Error("Swat is not initialized");
    }
    return new Promise(function (resolve, reject) {
        window._swat.fetch(function (res) {
            // console.log("res", res);
            // console.log("item", item);
            if (res.length === 0)
                reject(false);
            // check if item.id matches any of the res.epi
            var isRes = res.some(function (r) { return r.epi === item.id; });
            if (isRes)
                resolve(true);
            resolve(false);
        });
    });
};
